import { ApiBaseFront } from '../api-base-front';

type PrintOrderLockRequest = {
  kijshopCd: string,
  shopOrderId: string,
}
export type OrderLockCheckResponse = {
  name: string,
};

export class ApiPrintOrderLockCheck extends ApiBaseFront<OrderLockCheckResponse[]> {
  constructor(param: PrintOrderLockRequest) {
    const {
      kijshopCd,
      shopOrderId,
    } = param;
    super(
      'GET',
      `/api/v1/print/shop/${kijshopCd}/shopOrder/${shopOrderId}/lock`,
      'JSON',
      {},
    );
  }
}

type PostApiPrintLockRequest = {
  kijshopCd: string,
  shopOrderId: string,
  name: string
}

export class ApiPrintOrderLock extends ApiBaseFront {
  
  constructor(param: PostApiPrintLockRequest) {
    const {
      kijshopCd,
      shopOrderId,
    } = param;

    super(
      'POST',
      `/api/v1/print/shop/${kijshopCd}/shopOrder/${shopOrderId}/lock`,
      'JSON',
      {
        name: param.name,
      },
    );
  }
}

export class ApiPrintOrderUnlock extends ApiBaseFront {
  constructor(param: PrintOrderLockRequest) {
    const {
      kijshopCd,
      shopOrderId,
    } = param;

    super(
      'DELETE',
      `/api/v1/print/shop/${kijshopCd}/shopOrder/${shopOrderId}/lock`,
      'JSON',
      {},
    );
  }
}
